import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XFilterModel } from 'src/app/shared/interfaces/x-filter.model';
@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  baseUrl: string = '/auth/api/';

  constructor(private http: HttpClient) {}

  /** Institution*/
  getInstitution(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}Institution/${id}`);
  }

  getInstitutions(filter: XFilterModel): Observable<any> {
    const headers = new HttpHeaders({
      'X-filter': JSON.stringify(filter || {}),
    });
    return this.http.get<any>(`${this.baseUrl}Institution`, {
      headers,
      observe: 'response',
    });
  }

  getAllInstitutions(filter: XFilterModel): Observable<any> {
    const headers = new HttpHeaders({
      'X-filter': JSON.stringify(filter || {}),
    });
    return this.http.get<any>(`${this.baseUrl}Institution`, {
      headers,
      observe: 'response',
    });
  }

  exportInstitutionsToExcel(filter: XFilterModel): Observable<Blob> {
    const headers = new HttpHeaders({
      'X-filter': JSON.stringify(filter || {}),
    });
    return this.http.get(`${this.baseUrl}Institution/export-to-excel`, {
      headers,
      responseType: 'blob',
    });
  }

  updateInstitution(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}Institution/${id}`, data);
  }

  deleteInstitution(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}Institution/${id}`);
  }

  /** Person */
  getPerson(id: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}Person/${id}`);
  }

  updatePerson(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}Person/${id}`, data);
  }

  deletePerson(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}Person/${id}`);
  }

  /**Staff*/
  getStaff(id: string): Observable<any> {
    if (id) {
      return this.http.get<any>(`${this.baseUrl}Admin/staff/${id}`);
    }
    return new Observable<any>();
  }

  updateStaff(id: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}Admin/staff/${id}`, data);
  }

  deleteStaff(id: string): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}Admin/${id}`);
  }
}
